import axios from 'axios';
import jwtDecode /*, {decode}*/ from 'jsonwebtoken';
import {Notification} from 'element-ui';

export default {
  namespaced: true,
  state: () => ({
    status: 'loading', // loading, success, error, not-found, already-registered
    step: 1,
    accessToken: null,
    userRoles: null,
    donationRoles: null,
    eventDetail: null,
    eventConfig: null,
    donationConfig: null,
    oneClickJWT: null,
    tickets: [],
    participants: [],
    billingInfo: null,
    receipt: null,
    duplicateParticipant: null,
    donationDetail: null,
  }),
  mutations: {
    setStatus(state, payload) {
      state.status = payload;
    },
    setStep(state, payload) {
      state.step = payload;
    },
    setOneClickJWT(state, payload) {
      state.oneClickJWT = payload;
    },
    setAccessToken(state, payload) {
      state.accessToken = payload;
    },
    setUserRoles(state, payload) {
      state.userRoles = payload;
    },
    setDonationRoles(state, payload) {
      state.donationRoles = payload;
    },
    setEventDetail(state, payload) {
      state.eventDetail = payload;
    },
    setEventConfig(state, payload) {
      state.eventConfig = payload;
    },
    setDonationConfig(state, payload) {
      state.donationConfig = payload;
    },
    setTickets(state, payload) {
      state.tickets = payload;
    },
    setParticipants(state, payload) {
      state.participants = payload;
    },
    setBillingInfo(state, payload) {
      state.billingInfo = payload;
    },
    setReceipt(state, payload) {
      state.receipt = payload;
    },
    setDuplicateParticipant(state, payload) {
      state.duplicateParticipant = payload;
    },
    setDonationDetail(state, payload) {
      state.donationDetail = payload;
    }
  },
  actions: {

    // note getContactDetail will attempt to get url params and set user from cookie as fallback
    // todo: probably needs modification for impersonation situation
    async getDonationDetail({rootState, commit}) {

      const eventUser = rootState.auth.eventUser

      if (eventUser) {
        commit('setDonationDetail', eventUser)
        const decoded = jwtDecode.decode(eventUser.jwt, {complete: true})
        // commit('setAccessToken', eventUser.jwt)
        commit('setOneClickJWT', eventUser.jwt)

        const roles = decoded.payload?.Role
        if (roles) {
          commit('setDonationRoles', roles)
        }

        return true
      }

      // todo: verify if a notification is needed here
      // Notification.error({message: "We don’t seem to have a valid event for you at the moment. Please contact the event organizer for assistance."})
      return false


      /*

      try {

        const donationDetail = await dispatch('auth/getContactDetail', null, {root:true})

        if (donationDetail) {
          commit('setDonationDetail', donationDetail)
          const decoded = jwtDecode.decode(donationDetail.jwt, {complete: true});
          // commit('setAccessToken', donationDetail.jwt);
          commit('setOneClickJWT', donationDetail.jwt);
          commit('setDonationRoles', decoded.payload.Role);
        }
      } catch (error) {
        // commit('setStatus', 'invalid-ck-id');
        Notification.error({message: "We can't find your event at the moment"});
      }

*/
      /*
      axios.defaults.baseURL = rootState.baseURL;
      const {id, ck, token} = payload;

      /!*

                  {
                      method: 'post',
                          baseURL: rootState.baseURL,
                      url: `registration/authenticatedclick`,
                      headers: {'Authorization': `Bearer ${token}`},
                      // withCredentials: true
                  }
                  *!/

      if (!(id && ck)) {
        await dispatch('auth/setUserFromCookie', null, {root: true})
      }


      if ((id && ck) || state.auth.bearerToken) {

        try {

          const postRequest = id && ck
              ? {
                url: `registration/${id}/oneclick`,
                data: {
                  'one_click_token': ck,
                  "one_click_module": "CONTACT-UPDATE"
                }
              }
              : {
                url: `registration/authenticatedclick`,
                headers: {'Authorization': `Bearer ${state.auth.bearerToken}`}
              }


          const {data: donationDetail, error} = await axios.post(postRequest);

          if (donationDetail) {
            commit('setDonationDetail', donationDetail)
            const decoded = jwtDecode.decode(donationDetail.jwt, {complete: true});
            // commit('setAccessToken', donationDetail.jwt);
            commit('setOneClickJWT', donationDetail.jwt);
            commit('setDonationRoles', decoded.payload.Role);
          }
        } catch (error) {
          // commit('setStatus', 'invalid-ck-id');
          Notification.error({message: "We can't find your event at the moment"});
        }
      }
*/
    },
    async getInitialData({commit, rootState}, payload) {
      commit('setStatus', 'loading');
      axios.defaults.baseURL = rootState.baseURL;

      try {
        let initialStatus = 'success';

        if (payload.token !== '') {
          const decoded = jwtDecode.decode(payload.token, {complete: true});
          commit('setAccessToken', payload.token);
          commit('setUserRoles', decoded.payload.Role);
        }

        const {data: eventDetail} = await axios({
          method: 'post',
          url: `registration/event-details/${payload.eventCode}`,
          data: {}
        });
        commit('setEventDetail', eventDetail);

        if (eventDetail) {
          if (eventDetail.AlreadyRegistered) {
            initialStatus = 'already-registered';
          } else if (eventDetail.EventSoldOut) {
            initialStatus = 'sold-out';
          } else {
            const configRes = await axios({method: 'get', url: `config/event-type-${eventDetail.EventTypeCode}`});
            let eventConfig = configRes.data[`event-type-${eventDetail.EventTypeCode}`];

            eventConfig['oneclick-required'] = !!eventConfig['oneclick-required'];

            commit('setEventConfig', eventConfig);

            if (payload.func && typeof eventConfig['parameter-sets'] != 'undefined') {
              let selectedFunc = null;
              let parameterSets = JSON.parse(JSON.stringify(eventConfig['parameter-sets']).toLowerCase())
              const func = String(payload.func).toLowerCase();

              // let psIndex = parameter set index
              for (let psIndex = 0; psIndex < parameterSets.length; psIndex++) {
                const parameterSet = parameterSets[psIndex];
                if (parameterSet[func]) {
                  selectedFunc = parameterSet[func]
                }
              }

              if (selectedFunc) {
                let pricingTickets = eventDetail['PricingTicketOptions'];
                let eventCodes = selectedFunc['items'].map(func => {
                  return func['product-code']
                });

                pricingTickets = pricingTickets.filter(ticket => {
                  return eventCodes.indexOf(String(ticket.FunctionCode).toLowerCase()) >= 0;

                });

                eventDetail['PricingTicketOptions'] = pricingTickets;
                commit('setEventDetail', eventDetail);
              }
            }

            if (eventConfig['event-donation-config-set']) {
              const donationConfigRes = await axios({
                method: 'get',
                url: `config/${eventConfig['event-donation-config-set']}`
              });
              const donationConfig = donationConfigRes.data[eventConfig['event-donation-config-set']];


              commit('setDonationConfig', donationConfig);
            }
          }
        } else {
          initialStatus = 'not-found';
        }

        commit('setStatus', initialStatus);
        if (initialStatus === 'error') {
          Notification.error({message: "An error has occurred and we're unable to process your request"});
        } else if (initialStatus === 'not-found') {
          Notification.error({message: "We can't find your event at the moment"});
        }
      } catch (error) {
        commit('setStatus', 'error');
        console.log(error)
        Notification.error({message: "An error has occurred and we're unable to process your request"});
      }
    },
    async checkDuplicateRegister({state, rootState}, payload) {
      axios.defaults.baseURL = rootState.baseURL;

      const eventCode = state.eventDetail.EventCode;
      const {data} = await axios({
        method: 'post',
        url: `registration/${eventCode}/already-registered`,
        data: {...payload}
      });

      return {firstName: payload.FirstName, alreadyRegistered: data.AlreadyRegistered};
    },
    async sendPayment({state, rootState, rootGetters}, payload) {
      axios.defaults.baseURL = rootState.baseURL;

      const userHasStaffPaymentTypes = rootGetters['auth/userHasStaffPaymentTypes']

      try {
        let billingPayload;
        let freePayload = null;

        if (state.billingInfo) {
          if (state.billingInfo.type === 'individual') {
            billingPayload = {
              Jwt: state.billingInfo.jwt ? state.billingInfo.jwt : null,
              Individual: {
                Prefix: state.billingInfo.prefix,
                FirstName: state.billingInfo.first_name,
                LastName: state.billingInfo.last_name,
                Email: state.billingInfo.email,
                Mobile: state.billingInfo.mobile,
                Address: {
                  ...state.billingInfo.address,
                  address_2: "",
                  address_3: ""
                }
              }
            };
          } else {
            billingPayload = {
              Organisation: {
                OrganisationName: state.billingInfo.name,
                ABN: state.billingInfo.abn,
                Email: state.billingInfo.email,
                Mobile: state.billingInfo.mobile,
                Address: {
                  ...state.billingInfo.address,
                  address_2: "",
                  address_3: ""
                }
              }
            };
          }
        }

        const amountDonation = state.participants.donation + state.participants.customDonation;
        let amount = amountDonation;
        let tickets = [];
        state.tickets.forEach(ticket => {
          let ticketInfo = {FunctionCode: ticket.code, Quantity: ticket.value}
          let registrants = [];
          state.participants[ticket.code].forEach(participant => {
            let registrant = {
              Prefix: participant.prefix,
              FirstName: participant.firstName,
              LastName: participant.lastName,
              Email: participant.email,
              Mobile: participant.mobile,
              CompanyName: participant.companyName,
              CompanyTitle: participant.companyTitle,
              InformalName: participant.informalName,
              PostNominals: participant.postNominals,
              RegistrationComment: participant.registrationComment,
              Jwt: participant.Jwt
            }

            if (!freePayload) {
              freePayload = {
                Prefix: participant.prefix,
                FirstName: participant.firstName,
                LastName: participant.lastName,
                Email: participant.email,
                Mobile: participant.mobile,
                Address: null
              };
            }

            if (ticket.type === 'individual') {
              registrant.Diet = participant.dietaryRequirements || null;
              registrant.DietOther = participant.dietaryOther || null;
              registrant.Access = participant.accessibilityRequirements || null;
              registrant.AccessOther = participant.accessibilityOther || null;
            }

            registrants.push(registrant);
          });

          if (ticket.type === 'individual') {
            ticketInfo.Registrants = registrants;
          } else {
            ticketInfo.Captain = {...registrants[0]};
          }

          tickets.push(ticketInfo);
          amount += ticket.total;
        });

        const paymentData = {
          EventCode: state.eventDetail.EventCode,
          Tickets: [...tickets],
          DonationAmount: state.participants.useDonation ? amountDonation : null,
          Payment: {
            Amount: amount,
            ...billingPayload,
            ...payload
          },
          AdditionalEmailNotification: state.billingInfo && state.billingInfo.send_copy ? state.billingInfo.send_copy_email : null
        }


        let endPoint = 'registration/payment';
        let config = {};
        if (userHasStaffPaymentTypes) {
          endPoint = 'registration/staffpayment'
          config = {
            headers: {Authorization: `Bearer ${state.accessToken}`}
          };
        }


        if (!state.billingInfo) {
          paymentData.Payment['Individual'] = freePayload
        }


        const {data} = await axios({method: 'post', url: `${endPoint}`, data: {...paymentData}, ...config});
        return data;
      } catch (error) {
        console.log(error)
        Notification.error({message: "An error has occurred and we're unable to process your request"});
      }

      return null;
    }
  },
  getters: {}
}